import { useSelector } from 'react-redux'
import { selectors } from 'mage-state'

export default function useAvailableApps (tokenHelper) {
  return useSelector(selectors.getUserAccessibleApps)(tokenHelper).map(({ clientId }) => clientId)
}
